// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/added.php
export default {
	name: 'collection.added',
	priority: 78,
	require: function(config, filter) {
		return filter.collection && (filter.collection.added.from || filter.collection.added.to)
	},
	run: function(config, filter, data, query) {
		if (filter.collection.added.from) query.where('c.collection_date_owned', '>=', filter.collection.added.from)
		if (filter.collection.added.to) query.where('c.collection_date_owned', '<=', filter.collection.added.to)
	}
}
